
import { cn } from "@/lib/utils";
import { DealerHeader } from "./DealerHeader";

interface DealerCardSidebarProps {
  name: string;
  address: string;
  is_verified: boolean;
  city?: string;
  postal_code?: string;
  phone?: string;
  openingHours?: string;
  isFavorite: boolean;
  isHomePage?: boolean;
  isHorizontalLayout?: boolean;
  onToggleFavorite: (e: React.MouseEvent) => void;
}

export function DealerCardSidebar({
  name,
  address,
  is_verified,
  city,
  postal_code,
  phone,
  openingHours,
  isFavorite,
  isHomePage = false,
  isHorizontalLayout = false,
  onToggleFavorite
}: DealerCardSidebarProps) {
  return (
    <div className={cn(
      "flex flex-col",
      isHorizontalLayout && "md:w-1/3 md:border-r md:border-metal-light/20"
    )}>
      <DealerHeader 
        name={name}
        address={address}
        is_verified={is_verified}
        city={city}
        postal_code={postal_code}
        phone={phone}
        openingHours={openingHours}
        isFavorite={isFavorite}
        isHomePage={isHomePage}
        onToggleFavorite={onToggleFavorite}
      />
    </div>
  );
}
